module.exports = __webpack_public_path__ + "static/img/far2_active.fa1d4809.png";